import { motion } from "framer-motion";
import { Award, GraduationCap, Medal, BookOpen } from "lucide-react";

const QUALS = [
  {
    icon: Award,
    code: "Level 2",
    title: "Performing Arts (Dance)",
    desc: "Foundation diploma. Build technique, repertoire and stage craft.",
    duration: "1 Year · Full-Time",
  },
  {
    icon: Medal,
    code: "Level 3",
    title: "Extended Diploma",
    desc: "UCAS-accredited. Pre-degree training in choreography & performance.",
    duration: "2 Years · Full-Time",
  },
  {
    icon: BookOpen,
    code: "Level 4",
    title: "HND in Creative Practice",
    desc: "Industry-led specialism — choreography, teaching or production.",
    duration: "1 Year · Full-Time",
  },
  {
    icon: GraduationCap,
    code: "Level 6",
    title: "BA Pathway (In Development)",
    desc: "A future BA-level pathway is being developed.",
    duration: "Coming Soon",
  },
];

export const Qualifications = () => {
  return (
    <section
      id="qualifications"
      data-testid="qualifications-section"
      className="relative py-24 sm:py-32 bg-gradient-to-b from-black via-zinc-950 to-black"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="h-px w-10 bg-brand-yellow" />
            <span className="text-xs font-bold uppercase tracking-[0.3em] text-brand-yellow">05 · Qualifications</span>
            <span className="h-px w-10 bg-brand-yellow" />
          </div>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter">
            From first step <br />
            to <span className="text-brand-yellow text-glow-yellow">degree-level</span>.
          </h2>
          <p className="mt-6 text-zinc-400 text-base sm:text-lg">
            Accredited pathways for serious dancers. Every level connects to the next.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {QUALS.map((q, i) => (
            <motion.div
              key={q.title}
              data-testid={`qualification-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group relative p-7 rounded-2xl bg-zinc-950/60 border border-white/10 hover:border-brand-purpleLight/60 hover:-translate-y-2 transition-all duration-300"
            >
              <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity glow-purple pointer-events-none" />
              <q.icon className="text-brand-yellow mb-6" size={32} />
              <div className="text-[10px] uppercase tracking-[0.3em] text-brand-purpleLight font-bold mb-2">
                {q.code}
              </div>
              <h3 className="font-display font-black uppercase text-xl text-white tracking-tight">
                {q.title}
              </h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{q.desc}</p>
              <div className="mt-6 pt-5 border-t border-white/10 text-[11px] uppercase tracking-wider text-zinc-500">
                {q.duration}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
